import React from "react";

export default function CalendarIllustration() {
  return (
    <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="18" width="72" height="60" rx="8" fill="#f8fafc" stroke="#e2e8f0" strokeWidth="2" />
      <rect x="8" y="18" width="72" height="22" rx="8" fill="#e3f2fd" stroke="#e2e8f0" strokeWidth="2" />
      <rect x="8" y="32" width="72" height="8" fill="#e3f2fd" />
      <line x1="30" y1="10" x2="30" y2="26" stroke="#1976d2" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="58" y1="10" x2="58" y2="26" stroke="#1976d2" strokeWidth="2.5" strokeLinecap="round" />
      <rect x="16" y="46" width="12" height="9" rx="2" fill="#bbdefb" />
      <rect x="38" y="46" width="12" height="9" rx="2" fill="#bbdefb" />
      <rect x="60" y="46" width="12" height="9" rx="2" fill="#e8edf2" />
      <rect x="16" y="61" width="12" height="9" rx="2" fill="#e8edf2" />
      <rect x="38" y="61" width="12" height="9" rx="2" fill="#e8edf2" />
      <rect x="60" y="61" width="12" height="9" rx="2" fill="#e8edf2" />
    </svg>
  );
}
